import { Box, Typography } from '@mui/material';
import React from 'react';

const Dashboard = () => (
  <Box py={2}>
    <Typography variant="h3">Admin Dashboard</Typography>
  </Box>
);

export default Dashboard;
